import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b1d125a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "cancel-default"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "cancel-error"
}
const _hoisted_7 = {
  key: 0,
  class: "cancel-default"
}
const _hoisted_8 = {
  key: 1,
  class: "cancel-error"
}
const _hoisted_9 = {
  key: 2,
  class: "cancel-error"
}
const _hoisted_10 = { class: "cancel-error" }
const _hoisted_11 = {
  key: 0,
  class: "cancel-default"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "cancel-error"
}
const _hoisted_14 = {
  key: 0,
  class: "cancel-default"
}
const _hoisted_15 = {
  key: 1,
  class: "cancel-error"
}
const _hoisted_16 = { class: "cancel-error" }
const _hoisted_17 = { class: "el-dialog__body-footer flex-ter-end" }

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { productStatsEnum } from '@/views/usercenter/Order/data'

export default /*#__PURE__*/_defineComponent({
  props: ['statusList', 'visible', 'platformOrderType', 'isChoice'],
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props



// 直发订单
const contentList: any = {
  1: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[1]),
    warning: t('申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。'),
    error: t('请确认是否申请取消？')
  },
  2: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[2]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  },
  3: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[3]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  },
  4: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[4]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  },
  5: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[5]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  },
  6: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[6]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  },
  7: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[7]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  },
  8: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[8])
  },
  9: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[9])
  },
  10: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[10])
  },
  11: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[11])
  },
  12: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[12])
  },
  13: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[13])
  },
  14: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[14]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  }
}

// 囤货订单
const contentList2: any = {
  1: {
    default: t('当前申请取消的商品，商品状态均为“X”状态，申请取消成功后，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内').replace('X', productStatsEnum[1]),
    error: t('请确认是否申请取消？')
  },
  2: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[2])
  },
  3: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[3])
  },
  4: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[4])
  },
  5: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[5])
  },
  6: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[6])
  },
  7: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[7])
  },
  8: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[8])
  },
  9: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[9])
  },
  10: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[10])
  },
  11: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[11])
  },
  12: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[12])
  },
  13: {
    error: t('当前申请取消的商品，商品状态均为“X”状态，不可申请取消！').replace('X', productStatsEnum[13])
  },
  14: {
    default: t('当前申请取消的商品，商品状态均为“X”状态,').replace('X', productStatsEnum[14]),
    warning: t('申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。'),
    error: t('请确认是否申请取消？')
  }
}

const contentError = () => contentFn(props.statusList, (v: any) => (v > 1 && v <= 7) || v === 10)
const contentError2 = () => contentFn(props.statusList, (v: any) => v > 7 && v !== 10)

const contentFn = (list: any[], filter: any) => {
  const statusList = list.filter(filter).map((e: any) => productStatsEnum[e])
  return statusList.join('，')
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "custom-class": "cancel-dialog",
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('确认是否取消？')), 1),
      _createElementVNode("div", _hoisted_2, [
        (__props.platformOrderType == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.statusList.length < 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (contentList[__props.statusList[0]]?.default)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(contentList[__props.statusList[0]].default?.replace('お預かり金', __props.isChoice ? '支払額' : 'お預かり金')), 1))
                      : _createCommentVNode("", true),
                    _hoisted_4,
                    (contentList[__props.statusList[0]]?.warning && !__props.isChoice)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "cancel-warning",
                          innerHTML: contentList[__props.statusList[0]].warning
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    (contentList[__props.statusList[0]]?.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(contentList[__props.statusList[0]].error), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.statusList.includes(1))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('“X”状态商品，申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。').replace('X', _unref(productStatsEnum)[1])?.replace('お預かり金', __props.isChoice ? '支払額' : 'お預かり金')), 1))
                      : _createCommentVNode("", true),
                    (__props.statusList.some((v) => (v > 1 && v <= 7) || v === 10))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('“X”状态，申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。').replace('X', contentError())), 1))
                      : _createCommentVNode("", true),
                    (__props.statusList.some((v) => v > 7 && v !== 10 && v!== 14))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)('“X”状态商品，不可申请取消（系统将自动忽略）').replace('X', contentError2())), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('请确认是否申请取消？')), 1)
                  ], 64))
            ], 64))
          : _createCommentVNode("", true),
        (__props.platformOrderType == 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.statusList.length < 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (contentList2[__props.statusList[0]]?.default)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(contentList2[__props.statusList[0]].default?.replace('お預かり金', __props.isChoice ? '支払額' : 'お預かり金')), 1))
                      : _createCommentVNode("", true),
                    (contentList2[__props.statusList[0]]?.warning && !__props.isChoice)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "cancel-warning",
                          innerHTML: contentList2[__props.statusList[0]].warning
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    (contentList2[__props.statusList[0]]?.error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(contentList2[__props.statusList[0]].error), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.statusList.includes(1))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(t)('“X”状态商品，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内；').replace('X', _unref(productStatsEnum)[1])?.replace('お預かり金', __props.isChoice ? '支払額' : 'お預かり金')), 1))
                      : _createCommentVNode("", true),
                    (__props.statusList.some((v) => v > 1))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)('“X”状态商品，不可申请取消（系统将自动忽略）').replace('X', contentFn(__props.statusList, (v) => v > 1))), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('请确认是否申请取消？')), 1)
                  ], 64))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
          ]),
          _: 1
        }),
        (!((__props.platformOrderType === 1 && (!__props.statusList.some((t) => [1, 2, 3, 4, 5, 6, 7, 10, 14].indexOf(t) > -1))) || (__props.platformOrderType === 2 && __props.statusList.some((t) => t > 1))))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('submit')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认取消')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})